const STRINGS = {
  tr: {
    defaultIntro: 'Yeni sipariş bilgileri:',
    customer: 'Müşteri',
    note: 'Not',
    orderDetail: 'Sipariş Detayı',
    orderDetailFabric: 'Sipariş Detayı (Kumaş)',
    orderDetailMechanism: 'Sipariş Detayı (Mekanizma)',
    orderDetailMotor: 'Sipariş Detayı (Motor)',
    orderDetailAccessory: 'Sipariş Detayı (Aksesuar)',
    productName: 'Ürün Adı',
    productType: 'Ürün Tipi',
    usedMeter: 'Kullanılan Metre',
    mechanismType: 'Mekanizma Tipi',
    mechanism: 'Mekanizma',
    motor: 'Motor',
    motorNoRemote: 'Motor (kumandasız)',
    notSpecified: 'Belirtilmedi',
    quantity: 'Adet',
    accessories: 'Aksesuarlar',
    accessory: 'Aksesuar',
    noAccessoryInfo: 'Bilgi yok',
    accessoryFee: 'Aksesuar Ücreti',
    width: 'En(cm)',
    height: 'Boy(cm)',
    direction: 'Yön',
    systemType: 'Sistem Tipi',
    woodenZigil: 'Ahşap Zıgıl Sistemi',
    withReducer: 'Redüktörlü',
    withRibbon: 'Kurdelalı',
    metalZigil: 'Zıgıl Sistem Telli Takım',
    metalReducer: 'Redüktörlü',
    betweenGlass: 'İki Cam Arası Buton Sistem Takım',
    jumboSystem: 'Jumbo Sistem',
    bottomHemSlice: 'Alt Etek Dilim',
    closedCase: 'Kapalı Kasa',
    bottomHemLaser: 'Alt Etek Lazer',
    decorativeSlat: 'Dekoratif Lama',
    decorativeCase: 'Dekoratif Kasa',
    bottomHemWhiteWork: 'Alt Etek Beyaz İş',
    lining: 'Fon',
    liningYes: 'Var',
    kanatAstar: 'Astar',
    product1: '1. Ürün',
    product1Fabric: '1. Ürün Kumaş',
    productCase: 'Kasa',
    product2: '2. Ürün',
    product2Fabric: '2. Ürün Kumaş',
    measureList: 'Ölçü Listesi',
    totalSetQty: 'Toplam Set Adedi',
    legModel: 'Ayak Modeli',
    legDiameter: 'Ayak Çapı',
    legLength: 'Ayak Uzunluğu',
    colorCode: 'Renk Kodu',
    legCount: 'Ayak Sayısı',
    extraLegs: 'Ek',
    rayOptions: 'Ray Seçenekleri',
    multisistem: 'Multisistem',
    directionLeft: 'Sol',
    directionRight: 'Sağ',
    currencyTry: '₺',
    productTypes: {
      tul: 'Tül',
      kanat: 'Kanat',
      stor: 'Stor',
      zebra: 'Zebra',
      ahsapJaluzi: 'Ahşap Jaluzi',
      metalJaluzi: 'Metal Jaluzi',
      dikeyPerde: 'Dikey Perde',
      dikeyPvc: 'Dikey PVC',
      dikeyStor: 'Dikey Stor',
      plise: 'Plise',
      katlamaliPerde: 'Katlamalı Perde',
      raySistemi: 'Ray Sistemleri',
      rustik: 'Rustik',
      aksesuar: 'Aksesuar'
    }
  },
  en: {
    defaultIntro: 'New order details:',
    customer: 'Customer',
    note: 'Note',
    orderDetail: 'Order Details',
    orderDetailFabric: 'Order Details (Fabric)',
    orderDetailMechanism: 'Order Details (Mechanism)',
    orderDetailMotor: 'Order Details (Motor)',
    orderDetailAccessory: 'Order Details (Accessories)',
    productName: 'Product Name',
    productType: 'Product Type',
    usedMeter: 'Meters Used',
    mechanismType: 'Mechanism Type',
    mechanism: 'Mechanism',
    motor: 'Motor',
    motorNoRemote: 'Motor (no remote)',
    notSpecified: 'Not specified',
    quantity: 'Qty',
    accessories: 'Accessories',
    accessory: 'Accessory',
    noAccessoryInfo: 'No info',
    accessoryFee: 'Accessory Fee',
    width: 'Width (cm)',
    height: 'Height (cm)',
    direction: 'Direction',
    systemType: 'System Type',
    woodenZigil: 'Wood Zigzag System',
    withReducer: 'With reducer',
    withRibbon: 'With ribbon',
    metalZigil: 'Cord zigzag system set',
    metalReducer: 'With reducer',
    betweenGlass: 'Between-glass button system set',
    jumboSystem: 'Jumbo System',
    bottomHemSlice: 'Bottom hem slice',
    closedCase: 'Closed case',
    bottomHemLaser: 'Bottom hem laser',
    decorativeSlat: 'Decorative slat',
    decorativeCase: 'Decorative case',
    bottomHemWhiteWork: 'Bottom hem white finish',
    lining: 'Lining',
    liningYes: 'Yes',
    kanatAstar: 'Lining',
    product1: 'Product 1',
    product1Fabric: 'Product 1 fabric',
    productCase: 'Case',
    product2: 'Product 2',
    product2Fabric: 'Product 2 fabric',
    measureList: 'Measurement list',
    totalSetQty: 'Total set quantity',
    legModel: 'Leg model',
    legDiameter: 'Leg diameter',
    legLength: 'Leg length',
    colorCode: 'Color code',
    legCount: 'Leg count',
    extraLegs: 'Extra',
    rayOptions: 'Track options',
    multisistem: 'Multisystem',
    directionLeft: 'Left',
    directionRight: 'Right',
    currencyTry: 'TRY',
    productTypes: {
      tul: 'Sheer / Voile',
      kanat: 'Panel',
      stor: 'Roller blind',
      zebra: 'Zebra blind',
      ahsapJaluzi: 'Wood blinds',
      metalJaluzi: 'Metal blinds',
      dikeyPerde: 'Vertical blind',
      dikeyPvc: 'Vertical PVC',
      dikeyStor: 'Vertical roller',
      plise: 'Pleated blind',
      katlamaliPerde: 'Folded curtain',
      raySistemi: 'Track systems',
      rustik: 'Rustic',
      aksesuar: 'Accessory'
    }
  }
};

const normalizeLang = (language) => (language === 'en' ? 'en' : 'tr');

export const getWhatsAppLocale = (language) => (normalizeLang(language) === 'en' ? 'en-US' : 'tr-TR');

export const getWhatsAppString = (language, key, params = {}) => {
  const lang = normalizeLang(language);
  let text = STRINGS[lang][key] ?? STRINGS.tr[key] ?? key;

  Object.entries(params).forEach(([paramKey, value]) => {
    text = text.replace(new RegExp(`{{${paramKey}}}`, 'g'), value ?? '');
  });

  return text;
};

export const getWhatsAppProductType = (type, language) => {
  const lang = normalizeLang(language);
  return STRINGS[lang].productTypes[type] || STRINGS.tr.productTypes[type] || type;
};

export const getWhatsAppDefaultIntro = (firmaInfo, language) => {
  if (normalizeLang(language) === 'en') {
    return getWhatsAppString('en', 'defaultIntro');
  }
  return firmaInfo?.defaultMessage || getWhatsAppString('tr', 'defaultIntro');
};

export const formatWhatsAppDirection = (direction, language) => {
  if (!direction) return '';
  const normalized = String(direction).toUpperCase();
  if (normalized === 'LEFT' || direction === 'Sol') {
    return getWhatsAppString(language, 'directionLeft');
  }
  if (normalized === 'RIGHT' || direction === 'Sağ') {
    return getWhatsAppString(language, 'directionRight');
  }
  return direction;
};

export const formatWhatsAppMotorType = (motorType, language) => {
  if (!motorType) return '';
  if (motorType === 'Motor') {
    return getWhatsAppString(language, 'motorNoRemote');
  }
  if (motorType === 'Motor + Kumanda' && normalizeLang(language) === 'en') {
    return 'Motor + Remote';
  }
  return motorType;
};

// Ahşap/Metal jaluzi sistem tipi İngilizce karşılıkları (DB'de Türkçe saklanıyor)
const EN_SYSTEM_TYPES = {
  'Merdiven İpli': 'Cord ladder',
  'Kurdeleli': 'Ribbon',
  'Merdiven İpli Redüktörlü': 'Cord ladder with reducer',
  'Kurdelalı Redüktörlü': 'Ribbon with reducer'
};

export const formatWhatsAppSystemType = (sistemTipi, language) => {
  if (!sistemTipi) return '';
  if (normalizeLang(language) === 'en') {
    return EN_SYSTEM_TYPES[sistemTipi] || sistemTipi;
  }
  return sistemTipi;
};

export const formatWhatsAppNumber = (value, language) => {
  const num = parseFloat(value) || 0;
  return num.toLocaleString(getWhatsAppLocale(language));
};

export const line = (label, value) => (value !== undefined && value !== null && value !== '' ? `\n• ${label}: ${value}` : '');

export const checkLine = (label) => `\n• ${label}: ✓`;
